<div id="contact-main">
  <h1>Contact</h1>
  <p>You can contact me at the social media links above or on LinkedIn <a href="https://www.linkedin.com/in/austinsmyth/">here</a>.</p>
</div>
